import { Buffer } from 'buffer';

// Some wallet SDK internals still use Node.js globals even in browser builds.
// Install only the missing browser-safe shims before Angular or Reown code loads.
export type NodeBrowserPolyfillTarget = {
  Buffer?: typeof Buffer;
  global?: unknown;
  process?: {
    env?: Record<string, string>;
  };
};

export const installNodeBrowserPolyfills = (target: NodeBrowserPolyfillTarget): void => {
  // Reown can call bare `Buffer` from async chunks. Setting it on `globalThis`
  // makes the value available in both local and deployed browser bundles.
  target.Buffer ??= Buffer;

  // Some dependencies check `global` or `process.env` as Node compatibility probes.
  // Keep existing values if another polyfill/runtime has already provided them.
  target.global ??= target;
  target.process ??= { env: {} };
  target.process.env ??= {};
};

// This file is imported first from main.ts, so wallet dependencies see globals
// before any connector or modal code is evaluated.
installNodeBrowserPolyfills(globalThis as NodeBrowserPolyfillTarget);
